import { render, staticRenderFns } from "./mobile-footer.vue?vue&type=template&id=5e5de922&scoped=true"
import script from "./mobile-footer.vue?vue&type=script&setup=true&lang=js"
export * from "./mobile-footer.vue?vue&type=script&setup=true&lang=js"
import style0 from "./mobile-footer.vue?vue&type=style&index=0&id=5e5de922&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5de922",
  null
  
)

export default component.exports